import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "./chunks/tslib.es6.js";
import { JSONSupport as e } from "./core/JSONSupport.js";
import { isSome as r, andThen as s, mapOr as i } from "./core/maybe.js";
import { truncateDate as n, offsetDate as o } from "./core/timeUtils.js";
import { property as l } from "./core/accessorSupport/decorators/property.js";
import "./core/arrayUtils.js";
import "./core/has.js";
import "./core/accessorSupport/ensureType.js";
import { reader as a } from "./core/accessorSupport/decorators/reader.js";
import { subclass as m } from "./core/accessorSupport/decorators/subclass.js";
import { writer as p } from "./core/accessorSupport/decorators/writer.js";

var _u;

var d = _u = /*#__PURE__*/function (_e) {
  _inherits(u, _e);

  var _super = _createSuper(u);

  function u(t) {
    var _this;

    _classCallCheck(this, u);

    _this = _super.call(this, t), _this.end = null, _this.start = null;
    return _this;
  }

  _createClass(u, [{
    key: "readEnd",
    value: function readEnd(t, e) {
      return null != e.end ? new Date(e.end) : null;
    }
  }, {
    key: "writeEnd",
    value: function writeEnd(t, e) {
      e.end = t ? t.getTime() : null;
    }
  }, {
    key: "isAllTime",
    get: function get() {
      return this.equals(_u.allTime);
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.equals(_u.empty);
    }
  }, {
    key: "readStart",
    value: function readStart(t, e) {
      return null != e.start ? new Date(e.start) : null;
    }
  }, {
    key: "writeStart",
    value: function writeStart(t, e) {
      e.start = t ? t.getTime() : null;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _u({
        end: this.end,
        start: this.start
      });
    }
  }, {
    key: "equals",
    value: function equals(t) {
      if (!t) return !1;
      var e = r(this.start) ? this.start.getTime() : this.start,
          s = r(this.end) ? this.end.getTime() : this.end,
          i = r(t.start) ? t.start.getTime() : t.start,
          n = r(t.end) ? t.end.getTime() : t.end;
      return e === i && s === n;
    }
  }, {
    key: "expandTo",
    value: function expandTo(t) {
      if (this.isEmpty || this.isAllTime) return this.clone();
      var e = s(this.start, function (e) {
        return n(e, t);
      }),
          r = s(this.end, function (e) {
        return o(n(e, t), 1, t);
      });
      return new _u({
        start: e,
        end: r
      });
    }
  }, {
    key: "intersection",
    value: function intersection(t) {
      if (!t) return this.clone();
      if (this.isEmpty || t.isEmpty) return _u.empty;
      if (this.isAllTime) return t.clone();
      if (t.isAllTime) return this.clone();
      var e = i(this.start, -1 / 0, function (t) {
        return t.getTime();
      }),
          r = i(this.end, 1 / 0, function (t) {
        return t.getTime();
      }),
          s = i(t.start, -1 / 0, function (t) {
        return t.getTime();
      }),
          n = i(t.end, 1 / 0, function (t) {
        return t.getTime();
      });
      var o, l;

      if (s >= e && s <= r ? o = s : e >= s && e <= n && (o = e), r >= s && r <= n ? l = r : n >= e && n <= r && (l = n), !isNaN(o) && !isNaN(l)) {
        var _t = new _u();

        return _t.start = o === -1 / 0 ? null : new Date(o), _t.end = l === 1 / 0 ? null : new Date(l), _t;
      }

      return _u.empty;
    }
  }, {
    key: "offset",
    value: function offset(t, e) {
      if (this.isEmpty || this.isAllTime) return this.clone();
      var s = new _u(),
          i = this.start,
          n = this.end;
      return r(i) && (s.start = o(i, t, e)), r(n) && (s.end = o(n, t, e)), s;
    }
  }, {
    key: "union",
    value: function union(t) {
      if (!t || t.isEmpty) return this.clone();
      if (this.isEmpty) return t.clone();
      if (this.isAllTime || t.isAllTime) return c.clone();
      var e = r(this.start) && r(t.start) ? new Date(Math.min(this.start.getTime(), t.start.getTime())) : null,
          s = r(this.end) && r(t.end) ? new Date(Math.max(this.end.getTime(), t.end.getTime())) : null;
      return new _u({
        start: e,
        end: s
      });
    }
  }], [{
    key: "allTime",
    get: function get() {
      return c;
    }
  }, {
    key: "empty",
    get: function get() {
      return h;
    }
  }]);

  return u;
}(e);

t([l({
  type: Date,
  json: {
    write: {
      allowNull: !0
    }
  }
})], d.prototype, "end", void 0), t([a("end")], d.prototype, "readEnd", null), t([p("end")], d.prototype, "writeEnd", null), t([l({
  readOnly: !0,
  json: {
    read: !1
  }
})], d.prototype, "isAllTime", null), t([l({
  readOnly: !0,
  json: {
    read: !1
  }
})], d.prototype, "isEmpty", null), t([l({
  type: Date,
  json: {
    write: {
      allowNull: !0
    }
  }
})], d.prototype, "start", void 0), t([a("start")], d.prototype, "readStart", null), t([p("start")], d.prototype, "writeStart", null), d = _u = t([m("esri.TimeExtent")], d);
var c = new d(),
    h = new d({
  start: void 0,
  end: void 0
}),
    y = d;
export { y as default };